import { render, staticRenderFns } from "./WeeklyLeaderBoardPage.vue?vue&type=template&id=30e9b854&scoped=true&"
import script from "./WeeklyLeaderBoardPage.vue?vue&type=script&lang=js&"
export * from "./WeeklyLeaderBoardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e9b854",
  null
  
)

export default component.exports